import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SectionDefinitionService } from '../../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { AddNewSectionDefinitionDto, SectionDefinition, SectionDefinitionEntityType } from '../../../../models/section-definition.model';

@Component({
  selector: 'lib-add-new-section',
  templateUrl: './add-new-section.component.html',
  styleUrls: ['./add-new-section.component.scss'],
  standalone: false,
})
export class AddNewSectionComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();
  @Output() saved = new EventEmitter<{type: number, id?: number, substationTemplateId?: number}>();
  @Output() updated = new EventEmitter<{type: number, id?: number, substationTemplateId?: number}>();
  @Input() assetType!: SectionDefinitionEntityType;
  @Input() displayOrder!: number;
  @Input() utilityId!: number | null;
  @Input() section!: AddNewSectionDefinitionDto;
  @Input() isEdit: boolean = false;
  @Input() substationTemplateId?: number;
  @Input() equipmentType?: number;
  name: string = '';

  onCancel() {
    this.closeModal.emit();
  }

  constructor(private sectionDefinitionService: SectionDefinitionService, private toastr: ToastrService) {}

  ngOnInit(): void {
    if (this.section) {
      this.name = this.section.name;
    }
  }

  save() {   
    if (!this.isEdit) {
      if (this.name == '')
        this.toastr.warning("Name can't be empty!")
      else {
        var sectionDefinition = new AddNewSectionDefinitionDto();
        sectionDefinition.name = this.name;
        sectionDefinition.assetType = this.assetType;
        sectionDefinition.displayOrder = this.displayOrder;
        sectionDefinition.substationTemplateId = this.substationTemplateId;
        sectionDefinition.equipmentType = this.equipmentType;
        this.sectionDefinitionService.save(sectionDefinition, this.utilityId).subscribe({
          next: (response) => {
            if (response.status === 200 || response.status === 'OK') {
              this.toastr.success('Section added successfully.');
              setTimeout(() => {
                if (this.assetType != SectionDefinitionEntityType.SubstationTemplate)
                  this.saved.emit({type: this.assetType});
                else
                  this.saved.emit({type: this.assetType, substationTemplateId: this.substationTemplateId});
                this.onCancel();
              }, 500);
            } else {
              this.toastr.error(response.message);
            }
          },
          error: (_) => this.toastr.error('Error occured'),
        });
      }
    } else {
      this.section.name = this.name;
      this.sectionDefinitionService.save(this.section, this.utilityId).subscribe({
        next: (response) => {
          if (response?.body?.status === 200 || response?.body?.status === 'OK') {
            this.toastr.success('Section updated successfully.');
            setTimeout(() => {
              this.updated.emit({type: this.assetType});
              this.onCancel();
            }, 500);
          } else {
            this.toastr.error(response.message);
          }
          },
        error: (_) => this.toastr.error('Error occured'),
      });
    }
  }
}
